import { createSystem, defaultConfig, defineConfig } from '@chakra-ui/react';

const config = defineConfig({
  preflight: true,
  theme: {
    tokens: {
      fonts: {
        heading: { value: '"Syne Variable", Syne, sans-serif' },
        body: { value: '"Manrope Variable", Manrope, sans-serif' },
        mono: { value: 'ui-monospace, SFMono-Regular, Menlo, Consolas, monospace' },
      },
      colors: {
        night: { value: '#07080a' },
        hull: { value: '#12161c' },
        ice: { value: '#eef3f8' },
        mist: { value: '#c8d6e3' },
        dust: { value: '#b3c4d4' },
        steel: { value: '#8aa6bc' },
        sith: { value: '#c4001a' },
      },
    },
    semanticTokens: {
      colors: {
        bg: { value: 'var(--night)' },
        fg: { value: 'var(--fg)' },
        muted: { value: 'var(--dust)' },
        border: { value: 'var(--line)' },
      },
    },
  },
  globalCss: {
    html: {
      background: 'var(--night)',
      color: 'fg',
    },
    body: {
      background: 'var(--night)',
      color: 'fg',
      minHeight: '100dvh',
      fontFamily: 'body',
    },
    'h1, h2, h3, h4': {
      color: 'fg',
    },
    '::selection': {
      background: 'var(--sith)',
      color: 'var(--on-accent)',
    },
  },
});

export const system = createSystem(defaultConfig, config);
